import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-menu-grps',
  templateUrl: './menu-grps.component.html',
  styleUrls: ['./menu-grps.component.css']
})
export class MenuGrpsComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('menugrp_grid')
                .setLoadDataFunction({
                    method: 3485,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'menugrps_new',
                    text: 'menugrps_new',
                    tooltip: 'menugrps_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('menugrp', { menugrp_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
